import React from "react";
import { t } from "ttag";

import { GroupedTileModelsType } from "../../../../templates/ShopTileTemplate";

import styles from "./index.module.scss";

interface IModelSelectorProps {
    id: string;
    label: string;
    value: number | null;
    onChange: (productId: number) => void;
    groupedModels: GroupedTileModelsType;
    selectedProducts?: number[];
    className?: string;
    ariaLabel?: string;
    placeholder?: string;
}

export const ModelSelector = (props: IModelSelectorProps) => {
    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        if (value !== "" && value !== "placeholder") {
            props.onChange(parseInt(value));
        }
    };

    return (
        <div className={`${styles.modelSelector} ${props.className || ""}`}>
            <label htmlFor={props.id}>{props.label}</label>
            <select
                id={props.id}
                aria-label={props.ariaLabel || t`Select mattress model`}
                className="al-compare-tile-selectmodel"
                onChange={onSelectChange}
                value={props.value || "placeholder"}
            >
                {props.placeholder && (
                    <option value="placeholder" disabled>
                        {props.placeholder}
                    </option>
                )}
                {Object.entries(props.groupedModels).map(
                    ([groupTitle, models]) => (
                        <optgroup
                            key={`compare-tile-optgroup--${groupTitle}`}
                            label={groupTitle}
                        >
                            {models.map((model) => (
                                <option
                                    key={`compare-tile-model-option--${model.product}`}
                                    value={model.product}
                                    disabled={props.selectedProducts?.includes(
                                        model.product!,
                                    )}
                                >
                                    {model.title || ""}
                                </option>
                            ))}
                        </optgroup>
                    ),
                )}
            </select>
        </div>
    );
};
